// extracted by mini-css-extract-plugin
export default {"col":"ConnectedVariationsCol_col__N5FPj","title":"ConnectedVariationsCol_title__aDlcK","list":"ConnectedVariationsCol_list__u5g9s"};